import React, { ChangeEvent, useState } from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import { useStore } from 'effector-react'
import { $error, $landing, setLandingForm, submitCreateLanding } from './model'
import { languages } from 'src/libs/languages'
import { isUrlDomainMatching } from 'src/libs/utils'
import { ConfirmModal } from 'src/views/widgets/confirmModal'

export const CreateLanding: React.FC = () => {
  const [validated, setValidated] = useState(false)
  const [isConfirmDomainOpen, setIsConfirmDomainOpen] = useState(false)

  const landing = useStore($landing)
  const error = useStore($error)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setLandingForm({
      ...landing,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget
    event.preventDefault()
    event.stopPropagation()

    if (!form.checkValidity()) {
      setValidated(true)
      return
    }
    setValidated(true)

    if (!isUrlDomainMatching(landing.link)) {
      setIsConfirmDomainOpen(true)
      return
    }

    submitCreateLanding(landing)
  }

  const handleConfirmDomainSave = () => {
    setIsConfirmDomainOpen(false)
    submitCreateLanding(landing)
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create landing</strong>
      </CCardHeader>
      <CCardBody>
        {error.message.length > 0 && (
          <CAlert color="danger">Error: {error.message}</CAlert>
        )}
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                id="title"
                name="title"
                value={landing.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                id="link"
                name="link"
                value={landing.link}
                onChange={handleChange}
                minLength={3}
                required
                label="Link"
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Language"
                id="lang"
                name="lang"
                value={landing.lang}
                onChange={handleChange}
                required
              >
                {languages.map((language) => (
                  <option value={language.value}>{language.label}</option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormCheck
                id="isVisible"
                name="isVisible"
                checked={landing.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
          </CRow>
          <CButton className="mb-3" type="submit">
            Save
          </CButton>
        </CForm>
        <ConfirmModal
          isOpen={isConfirmDomainOpen}
          onSubmit={handleConfirmDomainSave}
          onCancel={() => setIsConfirmDomainOpen(false)}
          title="Подтверждение"
          message="Используется домен, отличный от headway.partners. Точно сохранить в таком виде?"
        />
      </CCardBody>
    </CCard>
  )
}
